export const ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY = 'onboarding-popular-feed-card:isDismissed';

export const FeedOnboardingKeys = [ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY] as const;
